// import axios from "axios"
import APIRequest from "./APIRequest"

// const API_BASE_URL = "http://192.168.18.242:5000/api"

// const api = axios.create({
//   baseURL: API_BASE_URL,
//   headers: {
//     "Content-Type": "application/json"
//   }
// })

// // Add token to requests
// api.interceptors.request.use(config => {
//   const token = localStorage.getItem("token")
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`
//   }
//   return config
// })

// // Handle token expiration
// api.interceptors.response.use(
//   response => response,
//   error => {
//     if (error.response?.status === 401) {
//       localStorage.removeItem("token")
//       localStorage.removeItem("user")
//       window.location.href = "/login"
//     }
//     return Promise.reject(error)
//   }
// )

export const authService = {
  login: async data => {
    const response = await APIRequest.post("/auth/login", data)
    return response.data
  },

  getCurrentUser: async () => {
    const response = await APIRequest.get("/auth/me")
    return response.data
  }
}

export const chatService = {
  getConversations: async (page = 1, limit = 20) => {
    const response = await APIRequest.get(
      `/chat/conversations?page=${page}&limit=${limit}`, { stopLoading: true }
    )
    return response.data
  },

  getOrCreateConversation: async userId => {
    const response = await APIRequest.get(`/chat/conversation/${userId}`)
    return response.data
  },

  getAdminInfo: async () => {
    const response = await APIRequest.get("/chat/admin-info")
    return response.data
  },

  getConversationWithAdmin: async () => {
    const response = await APIRequest.get("/chat/conversation/admin")
    return response.data
  },

  getAdminConversationWithUser: async userId => {
    const response = await APIRequest.get(`/chat/admin/conversation/${userId}`)
    return response.data
  },

  getMessages: async (conversationId, page = 1, limit = 50) => {
    const response = await APIRequest.get(
      `/chat/messages/${conversationId}?page=${page}&limit=${limit}`
    )
    return response.data
  },

  markMessagesAsSeen: async conversationId => {
    const response = await APIRequest.put(`/chat/messages/${conversationId}/seen`)
    return response.data
  },

  getOnlineUsers: async () => {
    const response = await APIRequest.get("/chat/online-users")
    return response.data
  },

  getAllUsers: async () => {
    const response = await APIRequest.get("/admin/verified-users",)
    return response.data
  },

  uploadFile: async file => {
    const formData = new FormData()
    formData.append("file", file)

    const response = await APIRequest.post("/chat/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    return response.data
  },

  getConversationParticipants: async conversationId => {
    const response = await APIRequest.get(`/chat/participants/${conversationId}`)
    return response.data
  },

  getUserOnlineStatus: async userId => {
    const response = await APIRequest.get(`/chat/user-status/${userId}`)
    return response.data
  }
}

// export default chatService
